import { useMemo } from 'react';
import tw from 'twin.macro';
import { Trans } from 'react-i18next';

import { IOrganizationUser } from '@account_module/types/Organizations';
import { CheckMarkIcon } from '@icons/CheckMarkIcon';

const Flex = tw.div`flex items-center justify-start gap-2 whitespace-nowrap`;
const BulkCheckbox = tw.button`w-[13px] h-[13px] border border-solid border-sec-2 rounded-sm flex items-center justify-center p-0 text-white`;

type DetailsHeadCellType = {
  data: IOrganizationUser[];
  selectedUsers: string[];
  setSelectedUsers: (item: string[]) => void;
};

export const DetailsHeadCell = ({
  data = [],
  selectedUsers,
  setSelectedUsers,
}: DetailsHeadCellType) => {
  const isSomeUserSelected = useMemo(
    () => selectedUsers.length > 0 && selectedUsers.length < data?.length,
    [selectedUsers]
  );
  const isAllUsersSelected = useMemo(
    () => selectedUsers.length === data?.length,
    [selectedUsers, data]
  );

  const handleChange = () => {
    if (!data.length) {
      return;
    }

    if (isAllUsersSelected || isSomeUserSelected) {
      setSelectedUsers([]);
      return;
    }

    setSelectedUsers(data.map((item: IOrganizationUser) => item.id));
  };

  const CheckIcon = useMemo(() => {
    if (isSomeUserSelected && selectedUsers.length < data?.length) {
      return '-';
    }

    if (selectedUsers.length === data?.length) {
      return <CheckMarkIcon tw='stroke-neutral-background w-2 h-2' />;
    }

    if (!selectedUsers.length) {
      return '';
    }
  }, [selectedUsers]);

  return (
    <Flex>
      <BulkCheckbox
        onClick={handleChange}
        css={[
          (isSomeUserSelected || isAllUsersSelected) &&
            data.length &&
            tw`bg-accent-muted border-accent-muted`,
        ]}>
        {CheckIcon}
      </BulkCheckbox>
      <Trans
        i18nKey='account_module.settings_page.users_table.members'
        values={{ count: data.length }}>
        Members (<span />)
      </Trans>
    </Flex>
  );
};
